import type { FC } from "react";

import { Markdown } from "../markdown/Markdown";
import styles from "./Text.module.css";

export type TextProps = {
  className?: string;
  content: string;
  size?: "large" | "medium" | "small";
};

export const Text: FC<TextProps> = ({
  className,
  content,
  size = "medium",
}) => {
  let style = styles.textReactMarkdown;

  if (size === "large") {
    style += ` ${styles.textReactMarkdownLarge}`;
  }

  if (size === "medium") {
    style += ` ${styles.textReactMarkdownMedium}`;
  }

  if (size === "small") {
    style += ` ${styles.textReactMarkdownSmall}`;
  }

  return <Markdown className={`${style} ${className}`}>{content}</Markdown>;
};
